import { render, staticRenderFns } from "./wine-collections-investor4.vue?vue&type=template&id=114dcea0&scoped=true"
import script from "./wine-collections-investor4.vue?vue&type=script&lang=js"
export * from "./wine-collections-investor4.vue?vue&type=script&lang=js"
import style0 from "./wine-collections-investor4.vue?vue&type=style&index=0&id=114dcea0&prod&scoped=true&lang=css"
import style1 from "./wine-collections-investor4.vue?vue&type=style&index=1&id=114dcea0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114dcea0",
  null
  
)

export default component.exports